import React from 'react';
import _ from 'lodash';
import { List } from '@mui/material';
import { FilterTree } from '../../promotion/promotion-details/FilterTree';
import Scrollbar from '../../../../../components/Scrollbar';

export const SimpleView = props => {
  const { data, treeObjects } = props;

  return (
    <Scrollbar sx={{ width: 450, maxHeight: 800 }}>
      <List disablePadding>
        {!_.isEmpty(treeObjects)
          ? <FilterTree data={treeObjects} initSelected={data ? data.init_selected_tree : []} disableSelection={true} />
          : null
        }
      </List>
    </Scrollbar>
  );
};
